import { List, Text } from "@ucl/react-library";
import { useTranslation } from "react-i18next";
import { ChallengeReasons } from "src/api/types/enums";

interface ChallengeReasonInfoProps {
  reason?: ChallengeReasons;
}

export const ChallengeReasonInfo = ({ reason }: ChallengeReasonInfoProps) => {
  const { t } = useTranslation();
  const base = `challengeReason.moreInfo.reasons.${reason}`;

  const intro = reason ? t(`${base}.intro`) : t("challengeReason.moreInfo.placeholder");
  const bullets = reason ? t(`${base}.bullets`, { returnObjects: true, defaultValue: [] }) : [];

  return (
    <div
      className="flex flex-col gap-5 rounded-xl bg-gray-100 p-5 text-start"
      data-testid="challengeReasonInfo"
      aria-live="polite"
    >
      <Text renderAs="h2" styleType="h4" fontWeight="semi-bold">
        {t("challengeReason.moreInfo.title")}
      </Text>

      <div className="flex flex-col gap-3">
        <Text.P size="large">{intro}</Text.P>

        {Array.isArray(bullets) && bullets.length > 0 && (
          <List size="medium" type="bullet">
            {bullets.map((bullet) => (
              <List.Item key={bullet}>
                <Text.P size="large" className="inline">
                  {bullet}
                </Text.P>
              </List.Item>
            ))}
          </List>
        )}
      </div>
    </div>
  );
};
